import { http, HttpResponse } from 'msw';

const mockNotFound = true;

export const getOngoinApplicationHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/ongoing_application', async () => {
        if (mockNotFound) {
            return new HttpResponse(null, {
                status: 404,
                statusText: 'No application found',
            });
        } else {
            return HttpResponse.json({ applicationReferenceNumber: '3fa85f64-5717-4562-b3fc-2c963f66afa6' });
        }
    }),
];
